'use client';
import { createClient } from '../../../common/client/client.js';

var client = createClient();

export { client };
